<template>
  <div class="">
    <div class="top_link">
      <div class="version">
        <p></p>

        <p>
          <img :src="require('assets/images/phone.png').default" /> 400-6891109
        </p>
      </div>
    </div>
    <div class="header">
      <div class="logobox">
        <div class="logo">
          <a :href="getDomainInfoa.backUrl" class="weblogo">
  <img src="@/assets/images/logo.png" />
  <span>{{ hotel.hotelname }}</span>
</a>

          <a href="#" class="h5logo"
            ><img src="@/assets/images/h5logo.png" /><span> </span
          ></a>
        </div>
        <div class="phone">
          <p>24小时订房热线</p>
          <h3 v-if="telphone">{{ telphone }}</h3>
        </div>
        <div class="menutips" @click="clicknav()"></div>
      </div>
    </div>
    <!-------导航开始-------------------->
    <div class="navbox" :class="{ cur: !showNav }">
      <div class="nav">
        <ul>
          <li
            :class="{ cur: currentURL == '/' || currentURL == '/index' }"
            @click="navigateTo('/')"
          >
            酒店首页
          </li>
          <li
            :class="{ cur: currentURL == '/booking' }"
            @click="navigateTo('/booking')"
          >
            酒店预订
          </li>
          <li
            :class="{ cur: currentURL == '/conference' }"
            @click="navigateTo('/conference')"
          >
            会议预订
          </li>
          <li
            :class="{ cur: currentURL == '/gallery' }"
            @click="navigateTo('/gallery')"
          >
            酒店图片
          </li>
          <li
            :class="{ cur: currentURL == '/services' }"
            @click="navigateTo('/services')"
          >
            服务设施
          </li>

          <li
            :class="{ cur: currentURL == '/reviews' }"
            @click="navigateTo('/reviews')"
          >
            顾客评论
          </li>
          <li
            :class="{ cur: currentURL == '/map' }"
            @click="navigateTo('/map')"
          >
            交通地图
          </li>
        </ul>
        <div class="closenav" @click="clickclose()">
          <img :src="require('assets/images/close.png').default" />
        </div>
      </div>
      <!-------导航结束-------------------->
    </div>
  </div>
</template>
<script>
import { gethoteldata, gethotelphone } from "network/home";
import { setStorage, getStorage } from "@/common/until/until";
import { UID } from "@/common/until/const";
import { getBlockList } from "network/block";
export default {
  name: "headerbox",

  data() {
    return {
      currentURL: null,
      previousId: null,
      hotel: {},
      showNav: true,
      Blockids: [],
      referer: "",
      elongid: "",
      source: "",
      session_hotel_id: "",
      domainMapData: [],
    };
  },
  async created() {
    // 必须先验证接口限制的hid，被屏蔽则停止后续请求
    const isBlocked = await this.NeedBlockids();
    if (isBlocked) return;

    this.getHoteltel();
    this.getNewsData();
    this.fetchDomainMap();
  },
  mounted() {
    // this.getstophotel();
    this.referer = document.referrer || "www.baidu.com";
    this.elongid = this.$route.query.hid;
    this.session_hotel_id = this.$route.query.hid;

    this.source =
      "source=" +
      this.$route.query.source +
      "&keyword=" +
      this.$route.query.keyword +
      "&account=" +
      this.$route.query.account;

    console.log(this.$route.query.uid);
    // this.sendbaidu();
  },
  methods: {
    // sendbaidu() {
    //   $.ajax({
    //     url: "http://api2.tetuijiudian.com/hotel/browsing/history/add",
    //     method: "POST",
    //     contentType: "application/json", // 设置内容类型为 JSON
    //     data: {
    //       elongid: this.elongid,
    //       source: this.source,
    //       referer: this.referer,
    //       session_hotel_id: this.elongid,
    //     },
    //   })
    //     .done((data) => {
    //       console.log("成功:", data);
    //     })
    //     .fail((jqXHR, textStatus, errorThrown) => {
    //       console.error("请求失败:", textStatus, errorThrown);
    //     });
    // },
    sendbaidu() {
      const url = "http://api2.tetuijiudian.com/hotel/browsing/history/add";
      const data = {
        id: this.elongid,
        referer: this.referer,
        source: this.source,
      };

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Network response was not ok " + response.statusText
            );
          }
          return response.json();
        })
        .then((data) => {
          console.log(data);
        })
        .catch((error) => {
          console.error(
            "There has been a problem with your fetch operation:",
            error
          );
        });
    },
    async NeedBlockids() {
      // 优先从 API 获取屏蔽酒店列表
      try {
        const res = await getBlockList();
        if (res && res.data) {
          this.Blockids = res.data.map((item) => String(item.zid));
        }
      } catch (e) {
        console.error("获取屏蔽酒店列表失败，使用本地静态数据:", e);
        // 降级：使用静态 JS 中的旧数据
        if (window.h_NeedBlockids) {
          this.Blockids = window.h_NeedBlockids.split("|");
        }
      }

      const cachedId = getStorage("cachedId");
      const hotelid = this.$route.query.hid || cachedId || "defaultHid";

      if (this.Blockids.includes(hotelid)) {
        this.$router.push("/Nopage");
        return true; // 被屏蔽
      }
      return false; // 未被屏蔽，可继续
    },
    clicknav() {
      this.showNav = !this.showNav;
    },
    fetchDomainMap() {
      const cached = localStorage.getItem("domainMapData");
      if (cached) {
        try {
          this.domainMapData = JSON.parse(cached);
          return;
        } catch (e) {}
      }
      fetch("https://csweb.xiaodianjia.cn/h5pay/bookUrl.php")
        .then((res) => res.json())
        .then((result) => {
          if (result.code === 200 && result.data) {
            this.domainMapData = result.data;
            localStorage.setItem("domainMapData", JSON.stringify(result.data));
          }
        })
        .catch((err) => {
          console.error("Failed to fetch domain map:", err);
        });
    },
    clickclose() {
      this.showNav = true;
    },
    navigateTo(route) {
      // console.log(route);
      this.currentURL = route;
      if (this.currentURL === "/Pay") {
        this.$router.push(route);
      } else {
        const query = { ...this.$route.query };
        this.$router.push({ path: route, query });
      }
    },
    getHoteltel() {
      const that = this;
      const cachedId = getStorage("cachedId");
      const hotelid = this.$route.query.hid || cachedId || "defaultHid";
      if (this.Blockids.includes(hotelid)) {
        this.$router.push("/Nopage");
      }
      $.ajax({
        url: "http://api2.tetuijiudian.com/book/book_pageview/getCityPhone",
        method: "GET",
        data: {
          eid: hotelid,
          fun: "getTel",
        },
      })
        .done(function (data) {
          that.getNewsData();
          
       

          var tels = data.tel
            ? data.tel
            : "400-6891109";
         

          // 将数据写入缓存
          localStorage.setItem("hotelphone", tels);
          setStorage("cachedId", hotelid);
          that.$store.commit("setHotelPhone", tels);
        })
        .fail(function (error) {
          // console.error("Error fetching hotel data:", error);
        });
      // 检查是否已经缓存了数据
      // if (cachedId && cachedId == hotelid && getStorage("hotelphone")) {
      //   // 从缓存中获取数据
      //   const tels = getStorage("hotelphone");
      //   that.$store.commit("setHotelPhone", tels);
      // } else {
      //   try {
      //     $.ajax({
      //       url: "https://admin.xiaodianjia.cn/api/book/book_pageview/getCityPhone",
      //       method: "GET",
      //       data: {
      //         eid: hotelid,
      //         fun: "getTel",
      //       },
      //     })
      //       .done(function (data) {
      //         that.getNewsData();
      //         var tels = data.tel ? data.tel : "400-6891109";
      //         // 将数据写入缓存
      //         localStorage.setItem("hotelphone", tels);
      //         setStorage("cachedId", hotelid);
      //         that.$store.commit("setHotelPhone", tels);
      //       })
      //       .fail(function (error) {
      //         // console.error("Error fetching hotel data:", error);
      //       });

      //     // try {
      //     // $.ajax({
      //     //      url: `https://admin.xiaodianjia.cn/api/book/book_pageview/getCityPhone?eid=${hotelid}&fun=getTel`,
      //     //     method: "POST", // Change to POST
      //     //     contentType: "application/json", // Set content type to JSON
      //     //     data: {},
      //     // })
      //     // .done(function (data) {
      //     //     that.getNewsData();
      //     //     var tels = data.tel;
      //     //     // 将数据写入缓存
      //     //     localStorage.setItem("hotelphone", tels);
      //     //     setStorage("cachedId", hotelid);
      //     //     that.$store.commit("setHotelPhone", tels);
      //     // })
      //     // .fail(function (error) {
      //     //     console.error("Error fetching hotel data:", error); // Log error
      //     // });
      //     // $.ajax({
      //     //   url: "https://tg2.tetuijiudian.com/apivhotel2/agentgettel",
      //     //   method: "GET",
      //     //   data: {
      //     //     hotelid: hotelid,
      //     //     uid: UID,
      //     //   },
      //     // })
      //     //   .done(function (data) {
      //     //     that.getNewsData();
      //     //     var tels = data.tel ? data.tel : data.tel400;
      //     //     // 将数据写入缓存
      //     //     localStorage.setItem("hotelphone", tels);
      //     //     setStorage("cachedId", hotelid);
      //     //     that.$store.commit("setHotelPhone", tels);
      //     //   })
      //     //   .fail(function (error) {
      //     //     // console.error("Error fetching hotel data:", error);
      //     //   });

      //     //   gethotelphone({
      //     //     hotelid,
      //     //     uid: UID,
      //     //   }).then((data) => {
      //     //     console.log(data);
      //     //     const tels = data.tel ? data.tel : data.tel400;
      //     //     // 将数据写入缓存
      //     //     localStorage.setItem("hotelphone", tels);
      //     //     setStorage("cachedId", hotelid);
      //     //     that.$store.commit("setHotelPhone", tels);
      //     //   });
      //   } catch (error) {
      //     // console.error("Error fetching hotel data:", error);
      //   }
      // }
    },
    getstophotel() {
      console.log(1111111);
      $.ajax({
        url: "http://api.tetuijiudian.com/shuia/statics/project/blockid.js",
        method: "GET",
        dataType: "jsonp",
        success: function (e) {
          console.log(1111111);
          console.log(e, "546545646546");
        },
      });
    },
    async getNewsData() {
      var that = this;
      const id = this.$route.query.hid || getStorage("cachedId");

      if (!id) {
        console.log("没有提供 id 参数！");
      } else if (id !== localStorage.getItem("cachedId")) {
        setStorage("cachedId", id);
      }

      const hotelStorage = getStorage("hoteldata");

      if (hotelStorage) {
        const cachedHotel = JSON.parse(hotelStorage);
        if (Number(cachedHotel.id) === Number(id)) {
          this.hotel = cachedHotel;
          this.previousId = id; // 更新上一次请求的 ID

          // 如果 Blockids 还未从 API 获取，降级使用静态数据
          if (this.Blockids.length === 0 && window.h_NeedBlockids) {
            this.Blockids = window.h_NeedBlockids.split("|");
          }
          if (this.Blockids.includes(id)) {
            return;
          }
          that.updateId(cachedHotel);
          return;
        }
      }
      await this.$nextTick();
      // try {
      //   $.ajax({
      //     url: "http://tg2.tetuijiudian.com/apivhotel2/apiwatugateway",
      //     method: "POST",
      //     dataType: "jsonp",
      //     data: {

      //       hid: id,
      //     },
      //     success: function (res) {
      //       that.hotel = res.reqdata;
      //       console.log(res.reqdata);

      //       document.title = res.reqdata.hotelname;
      //       that.previousId = id; // 更新上一次请求的 ID
      //       setStorage("hoteldata", JSON.stringify(res.reqdata));
      //       that.updateId(res.reqdata);
      //     },
      //     error: function (xhr, status, error) {
      //       console.log("AJAX request failed:", error);
      //     },
      //   });
      // } catch (error) {
      //   // console.error("Error fetching hotel data:", error);
      // }
      try {
        const res = await gethoteldata({
          method: "hotel.info",
          agent_id: "7596562",
          agent_md: "cee40804a5b2c83c",
          hid: id,
        });
        const hotelData = res.reqdata.reqdata || res.data || res;
        that.hotel = hotelData;
        console.log(hotelData);

        document.title = hotelData.hotelname;
        that.previousId = id;
        setStorage("hoteldata", JSON.stringify(hotelData));
        that.updateId(hotelData);
      } catch (error) {
        console.log("请求失败:", error);
      }
    },

    // http://tg2.tetuijiudian.com/apivhotel2/apiwatugateway?hid=5864
    updateId(hotelinfro) {
      this.$store.commit("updateId", hotelinfro); // 调用 Vuex Store 中的 mutation
    },
  },
  computed: {
    hotelinfro() {
      return this.$store.state.hotelinfro; // 访问 Vuex Store 中的状态
    },
    telphone() {
      return this.$store.state.hotelphone; // 访问 Vuex Store 中的状态
    },
    gethotename() {
      let hotelnames = this.$store.state.hotelnames; // 尝试从 Vuex Store 中获取值
      if (!hotelnames) {
        const hotelnamesFromLocalStorage =
          localStorage.getItem("hotelnameinfo"); // 从 localStorage 中获取值
        hotelnames = hotelnamesFromLocalStorage
          ? JSON.parse(hotelnamesFromLocalStorage)
          : null;
      }
      return hotelnames; // 返回赋值后的变量
    },
    getDomainInfoa() {
      const url = window.location.href;
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||  
        document.body.clientWidth;

      if (width <= 780) {
        return { status: 0, backUrl: "" };
      }

      const domainMap = this.domainMapData;

      const matched = domainMap.find((item) => url.includes(item.key));

      if (matched) {
        return {
          status: matched.status,
          backUrl: "/",
        };
      }

      return {
        status: 0,
        backUrl: "/",
      };
    },

  },
};
</script>

<style lang="less">
.top_link {
  width: 100%;
  background-color: #f9f9f9;
}

.version {
  width: 1150px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: #aaa;
}

.version p {
  display: flex;
  align-items: center;
  // background: url(~@/assets/images/i.png) 0 0 no-repeat ;
}

.version p img {
  margin-right: 5px;
}

.logobox {
  // overflow: hidden;
  padding: 11px 0;
  position: relative;
  min-height: 34px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo a {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  span {
    color: #11aa66;
    font-size: 30px;
    letter-spacing: 5px;
    font-weight: bold;
    position: relative;
  }
  span:before {
    position: absolute;
    left: -30px;
    content: "";
    display: block;
    width: 20px;
    height: 2px;
    background: #000;
    top: 50%;
    margin: -1px 0 0 0;
  }
}
.logo a img {
  margin-right: 40px;
  width: 80px;
}
.header {
  width: 1150px;
  margin: 0 auto;
  // overflow: hidden;
}

.version {
  height: 30px;
  line-height: 30px;
}

.navbox {
  height: 42px;
  line-height: 42px;
  background-color: #11aa66;
  margin-bottom: 23px;
  display: block;
}

.nav {
  width: 1150px;
  margin: 0 auto;
  text-align: right;
  overflow: hidden;
  .closenav {
    display: none;
  }
}

.nav ul {
  display: flex;
  justify-content: space-between;
}

.nav ul li {
  float: left;
  width: 150px;
  text-align: center;
}

.nav ul li {
  font-size: 16px;
  color: #fff;
  display: block;
  cursor: pointer;
}

.nav ul li.cur,
.nav ul li:hover {
  background-color: #0b8b52;
}
.nav ul li a {
  display: block;
}
.searchBox {
  width: 548px;
  margin: 0px 0 0 105px;
  float: left;
  height: 38px;
  border: 2px solid #0c9dde;
  position: relative;
  border-radius: 2px;
  background: #fff;
}

.searchBox .searchInput {
  border: none;
  line-height: 24px;
  height: 24px;
  width: 375px;
  margin: 7px 0;
  float: left;
  font-size: 14px;
  outline: none;
}

.searchBox .searchBtn {
  width: 68px;
  height: 42px;
  margin: -2px -2px 0 0;

  background-color: #0c9dde;
  border: none;
  float: right;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}

.swiper-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.phone {
  float: right;
  text-align: right;
}

.phone h3 {
  font-size: 28px;
  font-family: Arial;
  font-weight: bold;
  color: #ff5555;
}

.phone p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #555555;
}
.menutips {
  display: none;
}
.logo a.weblogo {
  display: flex;
}
.logo a.h5logo {
  display: none;
}

@media (min-width: 320px) and (max-width: 780px) {
  .logobox {
    min-height: 0;
    padding: 0;
  }
  .topheader {
    position: relative;
    z-index: 1000;
  }
  .navbox,
  .phone {
    display: none;
  }
  .header,
  .version {
    width: 100%;
    position: relative;
    z-index: 10000;
  }
  .version {
    padding: 0 10px;
    box-sizing: border-box;
    color: #ccc;
  }
  .logo {
    padding-top: 10px;
    position: absolute;
    top: -36px;
    padding-left: 10px;
    // padding-left: 10px;
    // padding-top: 9px;
    img {
      width: 30%;
      opacity: 0.15;
    }
    a {
      span {
        font-size: 16px;
        display: none;
      }
      span:before {
        width: 15px;
        background: #999;
      }
    }
    a.weblogo {
      display: none;
    }
    a.h5logo {
      display: block;
    }
  }
  .menutips {
    position: absolute;
    top: 27px;
    right: 20px;
    background: url(~@/assets/images/menu.png) center center no-repeat;
    background-size: 100%;
    width: 28px;
    height: 28px;
    display: block;
  }
  .cur {
    display: block;
  }
  .navbox {
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: 10000;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    .nav {
      width: 40%;
      height: 100%;
      float: right;
      background-color: #11aa66;
      .closenav {
        display: block;
        width: 28px;
        height: 28px;
        position: absolute;
        top: 10px;
        right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      ul {
        padding-top: 50px;
        flex-wrap: wrap;
        li {
          width: 100%;
          line-height: 48px;
        }
      }
    }
  }
}
</style>




 